import { jsx } from "react/jsx-runtime";
import { ListItemText as MUIListItemText } from "@mui/material";
import { forwardRef } from "react";
const ListItemTextInner = ({ ...restProps }, ref) => {
  return /* @__PURE__ */ jsx(
    MUIListItemText,
    {
      ...restProps,
      ref
    }
  );
};
const ListItemText = forwardRef(ListItemTextInner);
export {
  ListItemText
};
